import { useLazyQuery } from "@apollo/client/react"; import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';

import { RadioGroupInput } from '../../../../components/radioGroupInput/RadioGroupInput';
import { GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD } from '../../../../data/graphQL/queries/PlanCuidado/getTipoProfesionalEspecialidad';
import { GET_ALL_TIPO_PROFESIONALES } from '../../../../data/graphQL/queries/PlanCuidado/getTipoProfesionales';
import { adaptTipoProfesionalArray } from '../../../../adapters/tipoProfesionalAdapter';
import { adaptAllTipoProfesionalEspecialidadArray } from '../../../../adapters/allTipoProfesionalEspecialidadAdapter';
export const StepProfesionales = ({
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI,
  mostrarEspecialistas
}) => {
  const [profesionales, setProfesionales] = useState(fullFormDataRI?.profesionalRI ?? {
    profesionalRI: [],
    profesionalEspecialidadRI: []
  });
  const [profesionalesEspecialidad, setTipoProfesionalesEspecialidad] = useState();
  const [tiposProfesionales, setTipoProfesionales] = useState();

  const [getTipoProfesionales, { loading: tipoProfesionalesLoading, data: tipoProfesionalesData }] = useLazyQuery(GET_ALL_TIPO_PROFESIONALES, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!tipoProfesionalesData) return;

    setTipoProfesionales(adaptTipoProfesionalArray(tipoProfesionalesData));
  }, [tipoProfesionalesData]);

  const [getTipoProfesionalesEspecialidad, { loading: tipoProfesionalEspecialidadLoading, data: tipoProfesionalesEspecialidadData }] = useLazyQuery(GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!tipoProfesionalesEspecialidadData) return;

    setTipoProfesionalesEspecialidad(adaptAllTipoProfesionalEspecialidadArray(tipoProfesionalesEspecialidadData));
  }, [tipoProfesionalesEspecialidadData]);

  useEffect(() => {
    if (!tipoProfesionalesLoading) {
      getTipoProfesionales();
    }
    if (!tipoProfesionalEspecialidadLoading) {
      getTipoProfesionalesEspecialidad();
    }
  }, []);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [profesionales, setDataSubmissionCallback]);

  const handleSubmit = () => {
    updateFormData('profesionalRI', {
      ...profesionales
    });
  };

  const handleChange = (name, value) => {
    setProfesionales((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  return (
    <div>
      {mostrarEspecialistas && <div className='step-form-section-container' key={"TipoProfesional"}>
        <label className={`step-form-section-title`}> Equipo de seguimiento </label>
        <Grid
          container>
          {tiposProfesionales &&
            <RadioGroupInput
              adicionalValues={profesionales.profesionalRI}
              inputName="profesionalRI"
              options={tiposProfesionales}
              onChange={handleChange}
              row={false} />

          }
        </Grid>
      </div>}

      {mostrarEspecialistas && <div className='step-form-section-container' key={"ProfesionalEspecialidad"}>
        <label className={`step-form-section-title`}> Equipo de especialistas </label>
        <Grid
          container>
          {profesionalesEspecialidad &&
            <RadioGroupInput
              adicionalValues={profesionales.profesionalEspecialidadRI}
              inputName="profesionalEspecialidadRI"
              options={profesionalesEspecialidad}
              onChange={handleChange}
              row={false} />

          }
        </Grid>
      </div>}
    </div>);

};

export default StepProfesionales;